module.exports = __webpack_public_path__ + "static/media/thumbs-up-solid.cfcf661c.svg";